import React, {createRef} from "react";
import {connect} from "react-redux";
import {get} from '../../utils/api';
import {Link} from 'react-router-dom';
import {fetchUserRoles} from "../../actions/userActions";
import FilterModal from "./FilterModal"
import Loading from '../Shared/Loading';
import UserRows from './UserRows';
import './user.css';
import SVG from "react-inlinesvg";
import down from "../../assets/caret-down.svg"
import caretDown from "../../assets/chevron-right-solid.svg";
import DepartmentModal from "./DepartmentModal";

class Users extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
            loading: true,
            edit: false,
            query: '',
            sort: 'asc',
            status: true,
            activeFilter: [],
            show: {
                name: '',
                open: false
            },
            departments: [
                'Ad Operations',
                'Barometric',
                'Client Services',
                'Corporate',
                'Creative',
                'Data & Analytics',
                'Data Science',
                'Direct Access',
                'Information Security Office',
                'Marketing',
                'Media Operations',
                'Mktg, Strategy & Creative',
                'Partnerships',
                'Product',
                'Revenue Operations',
                'Sales',
                'Search & Social',
                'Strategy',
                'Supply',
                'Symetry',
                'Technology/R&D',
                'Yield'
            ]
        };
        this.usf = createRef();
        this.usfd = createRef();
        this.getRoles = this.getRoles.bind(this);

    }

    componentDidMount() {
        document.addEventListener("click", this.handleOutsideClick, false);
        this.props.dispatch(fetchUserRoles());
        this.getRoles();
     };
    componentWillUnmount() {
        document.removeEventListener("click", this.handleOutsideClick, false);
    }

    sortArray = (ascending) => {
        return function (a, b) {
            const nameA = a.full_name !== null ? a.full_name.toUpperCase().trim() : null; // ignore upper and lowercase
            const nameB = b.full_name !== null ? b.full_name.toUpperCase().trim() : null; // ignore upper and lowercase
            if (nameA === nameB) {
                return 0;
            }
            if (nameA === null) {
                return 1;
            }
            if (nameB === null) {
                return -1;
            }
            if (ascending) {
                return nameA < nameB ? -1 : 1;
            }
            return nameA < nameB ? 1 : -1;
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.state.sort !== prevState.sort){
            let userInfo = [...this.props.user];
            let updatedArray = [];
            if(this.state.sort === 'desc'){
                updatedArray = userInfo.sort(this.sortArray(false))
            }
            if(this.state.sort === 'asc'){
                updatedArray = userInfo.sort(this.sortArray(true))
            }
            this.setState({users: updatedArray})
        }
    }


    getRoles() {
        return get('users/roles')
            .then((res) => {
                let role = res.roles.map(function (item) {
                    return {
                        id: item.id,
                        label: item.role,
                        value: item.role
                    }
                });
                this.setState({
                    roles: role,
                    loading: false,
                })
            });
    }
    toggleModal = (item) => {
        this.setState({
            query: '',
            show: {
                name: item,
                open: !this.state.show.open
            }
        })
    }
    handleOutsideClick = ({ target }) => {
        if (this.usf.current && this.usf.current.contains(target)) {
            return;
        }
        if (this.usfd.current && this.usfd.current.contains(target)) {
            return
        }
        this.setState({
            show:{
                name: this.state.name, open: false
            }
        })
    }
    setQuery = (q) => {
        this.setState({query: q})
    }
    sortName = (q) => {
        this.setState({sort: q})
    }
    sortByStatus = (status) => {
        let userInfo = [...this.props.user];
        if(status){
            userInfo.sort((a,b) => {
                if (a.active < b.active) {
                    return -1;
                }
                if (a.active > b.active) {
                    return 1;
                }
                return 0;
            })
        }else{
            userInfo.sort((a,b) => {
                if (a.active < b.active) {
                    return 1;
                }
                if (a.active > b.active) {
                    return -1;
                }
                return 0;
            })
        }
        this.setState({status: !this.state.status, users:userInfo })
    }
    setDepartment = (array) => {
        let userInfo = [...this.props.user];
        userInfo = userInfo.filter(f => {
            if(f.department !== null && array.includes(f.department)){
                return f
            }
        })
        this.setState({
            show:{
                name: this.state.name, open: false
            },
            activeFilter: array,
            users: userInfo
        })

    }
    clearFilter = () =>{
        let userInfo = [...this.props.user];
        this.setState({
            users: userInfo
        })
    }
    setContent = () => {
        let query = this.state.query;
        let state = this.state.users;
        let array = this.props.user;
        if(state.length > 0){
            array = state
        }
        return array.filter(op => {
            if (query === '') {
                return op
            } else if (op.full_name !== null && op.full_name.toLowerCase().includes(query.toLowerCase())) {
                return op
            }
        }).map((user, k) => (
            <UserRows key={k} user={user} roles={this.state.roles}/>
        ));

    }

    render(){
        return(
            <div id="admin-container">
                <h2>Users</h2>
                <div className="search-table-wrapper">
                    <table className="admin-table" cellSpacing="0">
                        <thead>
                        <tr>
                            <th className={`user-sort-filter-name ${this.state.show.open && this.state.show.name === 'name' ? 'sort-active' : ''}`} ref={this.usf}>
                                <div className="inner-user-filter-container" onClick={() => this.toggleModal('name')}>
                                    <p>Name</p>
                                    <span className="caret">
                                        <SVG src={caretDown}/>
                                    </span>
                                </div>
                                {this.state.show.open && this.state.show.name === 'name' && <FilterModal setQuery={this.setQuery}  title={this.state.show.name} sort={this.sortName}  sortOrder={this.state.sort} option={this.props.user}/>}
                            </th>
                            <th className={`user-sort-filter-dept ${this.state.show.open && this.state.show.name === 'dept' ? 'sort-active' : ''}`} ref={this.usfd}>
                                <div className="inner-user-filter-container" onClick={() => this.toggleModal('dept')}>
                                    <p>Department</p>
                                    <span className="caret">
                                        <SVG src={caretDown}/>
                                    </span>
                                </div>
                                {this.state.show.open && this.state.show.name === 'dept' &&  <DepartmentModal setQuery={this.setQuery} addFilter={this.setDepartment} activeFilter={this.state.activeFilter}  clearFilter={this.clearFilter} departments={this.state.departments} title={this.state.show.name} option={this.props.user}/>}
                            </th>
                            <th>Office</th>
                            <th>Permissions</th>
                            <th>Joined Date</th>
                            <th>Last Login Date</th>
                            <th className={`user-sort-filter-status ${!this.state.status ? 'sort-active' : ''}`} onClick={() => this.sortByStatus(this.state.status)}>
                                <div className="inner-user-filter-container">
                                    Status
                                    <span className="caret-down">
                                        <SVG src={down}/>
                                    </span>
                                </div>

                            </th>
                        </tr>
                        </thead>
                        <tbody>
                            {this.setContent()}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => ({
    user: state.user.users
});
export default  connect(mapStateToProps)(Users);